import { render, staticRenderFns } from "./NotifPermissionBanner.vue?vue&type=template&id=3be1f163&scoped=true&"
import script from "./NotifPermissionBanner.vue?vue&type=script&lang=js&"
export * from "./NotifPermissionBanner.vue?vue&type=script&lang=js&"
import style0 from "./NotifPermissionBanner.vue?vue&type=style&index=0&id=3be1f163&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be1f163",
  null
  
)

export default component.exports